import { IPhone } from '../../types/offer';

interface IIsValidPhoneObject {
  phone?: IPhone | null;
}

export function isValidPhoneObject({ phone }: IIsValidPhoneObject) {
  return !!(phone && phone.countryCode && phone.code && phone.number);
}
